import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import './App.css';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import ResetPassword from './pages/ResetPassword';
import AcceptInvite from './pages/AcceptInvite';
import SmsConsent from './pages/SmsConsent';
import { Toaster } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const axiosInstance = axios.create({
  baseURL: API,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isCompanyAccount, setIsCompanyAccount] = useState(false);
  const [isCompanyEmployee, setIsCompanyEmployee] = useState(false);
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axiosInstance
        .get('/auth/me')
        .then((response) => {
          setIsAuthenticated(true);
          setIsAdmin(response.data.is_admin || false);
          setIsCompanyAccount(response.data.account_type === 'company');
          setIsCompanyEmployee(response.data.is_company_employee || false);
        })
        .catch(() => {
          localStorage.removeItem('token');
          setIsAuthenticated(false);
          setIsAdmin(false);
          setIsCompanyAccount(false);
          setIsCompanyEmployee(false);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              isAuthenticated ? (
                isAdmin ? (
                  <Navigate to="/admin" replace />
                ) : (
                  <Navigate to="/dashboard" replace />
                )
              ) : (
                <LandingPage setIsAuthenticated={setIsAuthenticated} setIsAdmin={setIsAdmin} />
              )
            }
          />
          <Route
            path="/dashboard"
            element={
              isAuthenticated && !isAdmin ? (
                <Dashboard setIsAuthenticated={setIsAuthenticated} />
              ) : isAdmin ? (
                <Navigate to="/admin" replace />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
          <Route
            path="/admin"
            element={
              isAuthenticated && isAdmin ? (
                <AdminDashboard setIsAuthenticated={setIsAuthenticated} />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
          <Route
            path="/reset-password"
            element={<ResetPassword />}
          />
          <Route
            path="/accept-invite/:token"
            element={<AcceptInvite setIsAuthenticated={setIsAuthenticated} />}
          />
          <Route
            path="/sms-consent"
            element={<SmsConsent />}
          />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;